import React, { useState, useEffect } from 'react';
import TimedDisplay from '../components/TimedDisplay';
import Popup from 'reactjs-popup';
import { Container, Row, Button, Form,Table, Col, Alert} from 'react-bootstrap';
import { useForm } from "react-hook-form";
import CommonUtils from '../utils/siteUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import { Loading } from '../components/Loading';
import { ConfirmModal } from '../components/ConfirmModal';
import '../styles/Admin.css';
export default function AdminSupplierSettings(props) {
    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();
    
    const [pending, setPending] = useState(true);
    const [vendor, setVendor] = useState([]);
    const [allowMaintenance, setAllowMaintenance] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const [addMsgLevel,setAddMsgLevel] = useState('');
    const [addMsg, setAddMsg] = useState('');
    const [isAdding, setIsAdding] = useState(false);
    const [isAddComplete, setIsAddComplete] = useState(false);
    const [currentComment, setCurrentComment] = useState("");
    const [adminCommentInvalid, setAdminCommentInvalid] = useState(false);
    const [adminCommentErrMsg, setAdminCommentErrMsg] = useState("");
    useEffect(() => {
        console.log(`NEW SUPPLIER: ${props.currentCompanyId}`);
       
        getSupplierAdminComments();       
        props.onChildUpdate();
    }, [props.currentCompanyId]);

    const getSupplierAdminComments = () => {
        if (!isAddComplete) {
            setPending(true);
        }        
        ServiceCalls.getSupplierAdminComments(props.currentCompanyId).then(function (data) {
            setVendor(data);
            setAllowMaintenance(data.allowMaintenanceMode);
            setPending(false);
        });
    }

    const onModeChange = () => {
        var newStatus = !allowMaintenance;
        setAllowMaintenance(newStatus);
        setShowConfirm(true);
    }
    const showAlertMessage =() => {
        if (isAddComplete) {
       
            return (<Col sm={12}><TimedDisplay delay="3000" callback={afterAlert}>
                <div style={{width:"100%"}}><Alert variant={addMsgLevel}>{addMsg}</Alert></div>
            </TimedDisplay></Col>);
            
        }
        else {
            return (<></>);
        }
    }   
    const renderTable = () => {
        var tblContent = (vendor.supplierComments.length > 0) ?
            vendor.supplierComments.map(function (item, idx) {
                return (<tr key={idx}>
                    <td>{item.createdDt}</td>
                    <td>{item.contactName}</td>
                    <td>{item.comment}</td>
                    <td>{CommonUtils.determineSupplierCommentType(item.commentTypeId)}</td>
                </tr>)
            })
            : <tr><td colSpan={4}>No History</td></tr>;

        return (     
            <Container className="flex-column borderCurve accessSearchArea">
                <Row><Col><h5>Supplier Profile Self-Maintenance History</h5></Col></Row>
                <Row>
                <Col>
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Action Taken By</th>
                            <th>Comment</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                    {tblContent}                        
                    </tbody>
                        </Table>
                    </Col></Row>
            </Container>
               );
    }
    const afterAlert = () => {
        closeModal();
        setPending(true);
        getSupplierAdminComments();        
    }
    const confirmCreate = () => {

        const htmlRegex = /(<([^>]+)>)/gi; // for HTML tags
        const urlRegex = /(http?:\/\/[^\s]+)/g; // for URLs

        var errMsg = "";
        if (currentComment === "") {
            errMsg = "A comment is required.";
        }
        if (htmlRegex.test(currentComment)) {
            errMsg ="HTML tags are not allowed.";
        }
        if (urlRegex.test(currentComment)) {
            errMsg = "URLs are not allowed";
        }
        setAdminCommentErrMsg(errMsg);

        if (currentComment !== "" && vendor.supplierId === props.currentCompanyId && errMsg==="") {
            setIsAdding(true);
            setAdminCommentInvalid(false);
            var adminSupplierInfoObj = buildAdminSupplierInfoObj();
            ServiceCalls.addSupplierComment(adminSupplierInfoObj).then(function (newComment) {
       
               var audit = {
                   severity: 'Informational',
                   message: `Set Supplier Maintenance Mode to ${allowMaintenance} for ${vendor.supplierName}`
                };
                ServiceCalls.postAuditLog(audit).then(function (result) {
                   
                    var msgLvl = (newComment.supplierCommentId > 0) ? "success" : "warning";
                    var msgText = (newComment.supplierCommentId > 0) ? `Successfully ${(allowMaintenance) ? "enabled" : "disabled"} Profile Maintenance for ${vendor.supplierName}` : `Failed to set Profile Maintenance to ${allowMaintenance} for ${vendor.supplierName}`
                    
                    setAddMsgLevel(msgLvl);
                    setAddMsg(msgText);
                    setIsAdding(false);
                    setIsAddComplete(true);
                    
                });
            });
        }
        else {
            console.log('Required Comment is empty');
            setAdminCommentInvalid(true);
        }
    }
    const buildAdminSupplierInfoObj = () => {
        var suppplierComment = {
            SupplierId: vendor.supplierId,
            AllowMaintenanceMode: allowMaintenance,
            SupplierComments: [
                {
                    Comment: currentComment,
                    CommentTypeId: (allowMaintenance) ? 1 : 2,
                    ContactId: props.currentUser.contactId
                }
            ]           
        }
        return suppplierComment;
    }
    const denyCreate = () => {
        var newStatus = !allowMaintenance;
        setAllowMaintenance(newStatus);       
        closeModal();
    }
    const closeModal = () => {    
        setAddMsgLevel("");
        setAddMsg("");
        setAdminCommentErrMsg("");
        setAdminCommentInvalid(false);
        setIsAdding(false);
        setIsAddComplete(false);
        setShowConfirm(false);    
        setCurrentComment("")
    }
    const renderModalBtns = () => {
        if (isAdding) {
            return (<Col sm={12}><Loading /></Col>);
        }
        else if (isAddComplete) {
            return (<></>);
        }
        else {
            return (
                <Col sm={12}>
                    <Button style={{ float: "right", marginLeft: "10px" }} className="OHCID-details-popup-buttons" onClick={() => { confirmCreate(); }}>
                        Yes
                    </Button>
                    <Button style={{ float: "right", marginRight: "10px" }} className="OHCID-details-popup-buttons" onClick={() => { denyCreate(); }}>
                        No
                    </Button>
                </Col>
            );
        }        
    }
    const onCommentChange = (e) => {
        setCurrentComment(e.target.value);
    }

    return (
        (pending) ?
            <Container style={{ marginTop: "10px", margin: "auto", width: "100px" }}>
                <Row>
                    <Col>
                        <Loading />
                    </Col>
                </Row>
            </Container>
            : <>
                <Container id="adminSupplierSettingsArea" className="flex-column borderCurve accessSearchArea">
                    <Row>
                        <Col sm={12}>
                            <h3>Supplier Settings</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={3}>
                            <h6 className="profileHdr">Supplier Set ID</h6>
                            {(vendor) ? vendor.vendorSetId : "NA"}
                        </Col>
                        <Col sm={3}>
                            <h6 className="profileHdr">Supplier ID</h6>
                            {(vendor) ? vendor.vendorId : "NA"}</Col>
                        <Col sm={6}>
                            <h6 className="profileHdr">Supplier Name</h6>
                            {(vendor) ? vendor.supplierName : "NA"}
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "20px"}}>
                    <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col sm={3}>
                            <h6>Allow Supplier Profile self-maintenance?</h6>
                        </Col>
                        <Col sm={3}>
                            <Form.Group as="div" controlId="supplierEnabled">
                                <Form.Switch
                                    type="switch"
                                    id="supplierStatus"
                                    checked={vendor.allowMaintenanceMode}
                                    onChange={onModeChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                           &nbsp;
                        </Col>
                    </Row>          
                    <Row>
                        <Col sm={12}>{renderTable()}</Col>
                    </Row>
                </Container>
                <Popup open={showConfirm} dialog closeOnDocumentClick={false}>
                    <Container id="adminSupplierSettingsModal" className="flex-column borderCurve">
                        <Row>
                            <Col><h4 id="adminConfirmHdr">Confirm Change</h4></Col>
                        </Row>
                        <Row>
                        <Col id="adminConfirmPolicyText">
                            Are you sure you want to {(allowMaintenance)?"enable":"disable"} the Supplier Profile self-maintenance setting?
                            </Col>
                        </Row>
                        <Row>
                        <Col>
                            <Form name="adminPolicyAdd" id="adminPolicy">
                                <Form.Group className="mb-3" controlId="formComment">
                                    <Form.Label></Form.Label>
                                        <Form.Control as="textarea"
                                            required={true}
                                            maxLength="500"
                                        onChange={onCommentChange}
                                            isInvalid={adminCommentInvalid}
                                        rows="5"                                     
                                        placeholder="Enter required comments" />

                                        <Form.Text className="text-muted">{adminCommentInvalid && <p role="alert" className="error">{adminCommentErrMsg}</p>}</Form.Text>
                                </Form.Group>                            
                            </Form>                               
                            </Col>
                        </Row>
                        <Row><Col> {500 - currentComment.length} of 500</Col></Row>
                        <Row>                           
                            {showAlertMessage()} 
                            {renderModalBtns()}                                                 
                        </Row>
                    </Container>
                </Popup>
            </>
    );
}